import { createSlice } from '@reduxjs/toolkit';
import {
  getContactDetails,
  UpdateContactDetails,
  getAssociatedInvestments,
  getReferenceContacts,
} from '../thunk/contactThunks';
const initialState = {
  contactDetails: [],
  associatedInvestments: [],
  referenceContactData: [],
  loading: false,
  updating: false,
  error: null,
  associatedInvestmentsLoading: false,
  referenceContactDataLoading: false,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearContactDetails: (state) => {
      state.contactDetails = [];
      state.error = null;
      state.associatedInvestments = [];
      state.referenceContactData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getContactDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.contactDetails = action.payload.data;
      })
      .addCase(getContactDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Contact Details
      .addCase(UpdateContactDetails.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(UpdateContactDetails.fulfilled, (state, action) => {
        state.updating = false;
        state.contactDetails = action.payload.data;
      })
      .addCase(UpdateContactDetails.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      })

      // Associated Investments
      .addCase(getAssociatedInvestments.pending, (state) => {
        state.associatedInvestmentsLoading = true;
        state.error = null;
      })
      .addCase(getAssociatedInvestments.fulfilled, (state, action) => {
        state.associatedInvestmentsLoading = false;
        state.associatedInvestments = action.payload.data;
      })
      .addCase(getAssociatedInvestments.rejected, (state, action) => {
        state.associatedInvestmentsLoading = false;
        state.error = action.payload;
      })

      // Reference Calls
      .addCase(getReferenceContacts.pending, (state) => {
        state.referenceContactDataLoading = true;
        state.error = null;
      })
      .addCase(getReferenceContacts.fulfilled, (state, action) => {
        state.referenceContactDataLoading = false;
        state.referenceContactData = action.payload.data;
      })
      .addCase(getReferenceContacts.rejected, (state, action) => {
        state.referenceContactDataLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearContactDetails } = contactSlice.actions;
export default contactSlice.reducer;
